module.exports = __webpack_public_path__ + "static/bicycle-97c0b8d7705f589cc5ac3eade6699b07.gif";